import React, { useEffect, useState } from "react";
import ScrollToTopButton from "./ScrollToTopButton";
import { NavLink } from "react-router-dom";

const Careers = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState('');
    const [experience, setExperience] = useState('');
    const [message, setMessage] = useState('');
    const [file, setFile] = useState(null);
    const [loading, setLoading] = useState(false);

    // Handle file upload
    const handleFileChange = (event) => {
        setFile(event.target.files[0]); // Store the file in state
    };
    return (
        <>
            <div className="Careers-mainsection">
                <ScrollToTopButton />
                <div className='container-fluid'>
                    <div className='aboutus-bgsection'>
                        <div className='container'>
                            <h2 className='aboutus-header'>Careers</h2>
                            <div>
                                <h3 className='pages-head'> <NavLink to={'/'} className="about-s">HOME</NavLink> <img className='' src='../assets/images/icon_rightabout.png' alt='arrow' />Careers</h3>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="Careers-section">
                    <div className="careers-sec">
                        <div className="container">
                            <div className="row">
                                <div className="col-md-8">
                                    <div className="careers-secleft">
                                        <div className="careers-leftimdot">
                                            <img className="careers-leftim" src="../../../assets/images/career.jpg" alt="WE ARE HIRING" />
                                        </div>
                                        <div className="careers-lefttxtsec">
                                            <h3 className="careers-title">WE ARE HIRING</h3>
                                            <p className="careers-title2">
                                                <span> Offshore Hiring: </span>
                                                Join the 4Sight Tech team! We have exciting opportunities for Business Development Manager (BDM), US IT Recruiter, and Bench Sales Recruiter positions. If you are skilled in these roles, come be a part of our innovative team and contribute to our growth. Apply now to advance your career with 4Sight Tech!
                                            </p>
                                            <p className="careers-title2">
                                                <span> USA Hiring: </span>
                                               
                                                The 4Sight Tech team maintains extensive connections with leading companies across diverse industries, giving us access to a wide variety of job opportunities. Our expertise spans evaluating open positions, matching candidates with their ideal roles, and supporting applicants throughout every step of the hiring process. From resume preparation to interview coaching, we provide personalized guidance to help you secure the perfect career fit. Explore our placement board or reach out to us for expert advice and effective strategies for career success. Ready to take the next step? Drop your resume here and let us help you achieve your professional goals.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="careers-rightim">
                                        <img src="../../../assets/images/2149085.jpg" alt="WE ARE HIRING" />
                                        <img className="careers-rightim2" src="../../../assets/images/214908522.jpg" alt="WE ARE HIRING" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="container">
                        <div className="row">
                            <div className="col-md-6">
                                <h3 className="apply-head">Apply With Resume</h3>
                                <form
                                // onSubmit={sendEmail}
                                >
                                    <div className="applysec">
                                        <div className="row">
                                            <div className="col-md-3">
                                                <p className="apply-lbl">Name *</p>
                                            </div>
                                            <div className="col-md-8">
                                                <input
                                                    type="text"
                                                    className="form-control apply-inp"
                                                    value={name}
                                                    onChange={(e) => setName(e.target.value)}
                                                    placeholder="Enter your name"
                                                    required
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="applysec">
                                        <div className="row">
                                            <div className="col-md-3">
                                                <p className="apply-lbl">Email *</p>
                                            </div>
                                            <div className="col-md-8">
                                                <input
                                                    type="email"
                                                    className="form-control apply-inp"
                                                    value={email}
                                                    onChange={(e) => setEmail(e.target.value)}
                                                    placeholder="Enter your email"
                                                    required
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="applysec">
                                        <div className="row">
                                            <div className="col-md-3">
                                                <p className="apply-lbl">Phone *</p>
                                            </div>
                                            <div className="col-md-8">
                                                <input
                                                    type="text"
                                                    className="form-control apply-inp"
                                                    value={phone}
                                                    onChange={(e) => setPhone(e.target.value)}
                                                    placeholder="Enter your phone number"
                                                    required
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="applysec">
                                        <div className="row">
                                            <div className="col-md-3">
                                                <p className="apply-lbl">Resume/CV *</p>
                                            </div>
                                            <div className="col-md-8">
                                                <input
                                                    type="file"
                                                    id="formFile"
                                                    className="file-input"
                                                    onChange={handleFileChange}
                                                    required
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="applysec">
                                        <div className="row">
                                            <div className="col-md-3">
                                                <p className="apply-lbl">Experience *</p>
                                            </div>
                                            <div className="col-md-8">
                                                <select
                                                    className="form-select apply-inp"
                                                    value={experience}
                                                    onChange={(e) => setExperience(e.target.value)}
                                                    required
                                                >
                                                    <option value="" disabled>Choose...</option>
                                                    <option value="1">1 year</option>
                                                    <option value="2">2 years</option>
                                                    <option value="3">3 years</option>
                                                    <option value="4">4 years</option>
                                                    <option value="5">5 years</option>
                                                    <option value="6">6 years</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="applysec">
                                        <div className="row">
                                            <div className="col-md-3">
                                                <p className="apply-lbl">Message</p>
                                            </div>
                                            <div className="col-md-8">
                                                <textarea
                                                    rows={4}
                                                    style={{ width: '100%' }}
                                                    value={message}
                                                    onChange={(e) => setMessage(e.target.value)}
                                                    placeholder="Type your message here..."
                                                    required
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="applysec">
                                        <div className="row">
                                            <div className="col-md-3"></div>
                                            <div className="col-md-8">
                                                <button className="applybt" type="submit" disabled={loading}>
                                                    {loading ? "Sending..." : "Submit Application"}
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                            <div className="col-md-6">
                                <img className="form-im" src="../../../assets/images/5562385.jpg" alt="WE ARE HIRING" />
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </>
    )
}

export default Careers;